import React, { useState } from "react";

const styles = {
  centerScreen: { minHeight:"100vh", width:"100%", display:"flex", alignItems:"center", justifyContent:"center", background:"#1E5631", padding:"12px", boxSizing:"border-box" },
  card: { width:"100%", maxWidth:"440px", background:"#fff", borderRadius:"16px", padding:"28px 20px", boxShadow:"0 8px 24px rgba(0,0,0,0.18)", boxSizing:"border-box", margin:"0 auto" },
  input: { width:"100%", padding:"14px 14px", fontSize:"17px", border:"1.5px solid #C9CDC4", borderRadius:"10px", marginBottom:"14px", boxSizing:"border-box", background:"#fff" },
  btnPrimary: { width:"100%", padding:"14px", fontSize:"18px", fontWeight:"bold", color:"#fff", background:"#1E5631", border:"none", borderRadius:"10px", cursor:"pointer" }
};

function LogoRumahSVG() {
  return (
    <svg width="110" height="110" viewBox="0 0 100 100" style={{ marginBottom:"10px" }}>
      <circle cx="50" cy="50" r="46" fill="#EBF5ED" />
      <rect x="35" y="48" width="30" height="28" rx="2" fill="#1E5631" />
      <rect x="47" y="60" width="6" height="16" fill="#FFF" opacity="0.9" />
      <rect x="39" y="53" width="5" height="5" rx="1" fill="#FFF" opacity="0.9" />
      <rect x="56" y="53" width="5" height="5" rx="1" fill="#FFF" opacity="0.9" />
      <polygon points="50,28 31,49 69,49" fill="#C24C4C" />
      <path d="M 10,75 Q 50,70 90,75 L 90,85 Q 50,85 10,85 Z" fill="#60A864" />
    </svg>
  );
}

function LoginScreen({ onLoginWarga, error }){
  const [houseNo, setHouseNo] = useState("");
  const [pass, setPass] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e)=>{
    e.preventDefault();
    setLoading(true);
    await onLoginWarga(houseNo, pass);
    setLoading(false);
  };

  return (
    <div style={styles.centerScreen}>
      <div style={styles.card}>
        <div style={{textAlign:"center", marginBottom:"22px"}}>
          <LogoRumahSVG />
          <div style={{fontSize:"23px", fontWeight:"bold", color:"#1E5631", marginTop:"2px"}}>Aplikasi IPL Warga</div>
          <div style={{fontSize:"14px", color:"#000000", marginTop:"8px", lineHeight:"1.4", padding:"0 6px"}}>
            Perum Pesona Ciputih Blok C, RT. 12 RW 4 Kel. Sukamulya Kec. Rumpin
          </div>
        </div>
        <form onSubmit={submit}>
          <input style={styles.input} placeholder="Nomor rumah (contoh: C1/5)" value={houseNo} onChange={e=>setHouseNo(e.target.value)} autoCapitalize="characters" />
          <input style={styles.input} type="password" placeholder="Password Anda" value={pass} onChange={e=>setPass(e.target.value)} />
          {error && <div style={{color:"#B23B3B", fontSize:"14px", fontWeight:"bold", marginBottom:"10px"}}>{error}</div>}
          <button style={styles.btnPrimary} type="submit" disabled={loading}>{loading ? "Memuat..." : "Masuk"}</button>
        </form>
      </div>
    </div>
  );
}
export default LoginScreen;